import axios from 'axios';

type togglePayload = {
  globalAdminCanAccessBilling?: boolean;
  managerCanAccessBilling?: boolean;
};

const toggleAccessBill = async (payload: togglePayload) => {
  await axios.post('/org/toggle_access_bill', payload);
};

export default toggleAccessBill;
